function findCounterTrial(listTrials,listCounterTrial,listType)
{
  var flagsStart = new Array();
  var flagsEnd = new Array();
  var flagsMax = new Array();
  for (var i = 0; i < listTrials.length; i++) 
  {
    //in case first trial should be randomised
    if (i == 0 && listCounterTrial[i] != "na")
      {
        flagsStart.push(i);
      }
    //for all trials except last
    if (i != listTrials.length-1)
    {
      if (listCounterTrial[i]!=listCounterTrial[i+1])
      {
        if (listCounterTrial[i]=="na")
        {
          flagsStart.push(i+1);
        }
        else if (listCounterTrial[i+1]=="na")
        {
          flagsEnd.push(i);
        }
        else
        {
          flagsStart.push(i+1);
          flagsEnd.push(i);
        }
      }
      else if (listCounterTrial[i]!="na" && listType[i]!=listType[i+1])
      {
        flagsStart.push(i+1);
        flagsEnd.push(i);
      }
    }
    //in case last trial should be randomised
    if (i == listTrials.length-1 && listCounterTrial[i] != "na" && listType[i] != "instructions"){flagsEnd.push(i);}
  }

  //compute counter trial info for each trial in listTrials; is there a more efficient way??
  counterTemp = 0;
  stimOrderCounterTrialMax = [];
  for (var j = 0; j < flagsStart.length; j++)//add info for trials between flags
  {
    counterTemp = 0;
    for (var i = flagsStart[j]; i < flagsEnd[j]+1; i++)
    {
      counterTemp = counterTemp + 1;
      // if (listCounterTrial[i] == 1)
      // {
        stimOrderCounterTrialMax[i] = flagsEnd[j] - flagsStart[j] + 1;
      // }
      // else
      // {
      //   stimOrderCounterTrialMax[i] = listCounterTrial[i];
      // }
      stimOrderCounterTrial[i] = counterTemp + '/' + stimOrderCounterTrialMax[i];
    }
  }

  return stimOrderCounterTrial;

}